import { Box, Typography, useTheme } from "@mui/material";
import FooterLayout from "../footer/footer-layout.js";
import NavigationLayout from "../navigation/navigation-layout.js";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/form/custom-button.js";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';

const NotFoundLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh'
                }}
            >
                <NavigationLayout />

                <Box
                    flexGrow={1}
                    className="navigationTopSpacing bodySideMargin1"
                >
                    <Stack
                        direction={{xs: 'column', md: 'row'}}
                        alignItems={{xs: 'start', md: 'center'}}
                        justifyContent='center'
                        className="sectionInSidePadding"
                    >
                        <Box
                            sx={{
                                width: {xs: '100%', md: '50%'}
                            }}
                        >
                            <img 
                                src="/images/404/404.png" 
                                alt="404" 
                                width='100%'
                                style={{
                                    display: 'block'
                                }}
                            />
                        </Box>

                        <Stack
                            direction='column'
                            alignItems='center'
                            width={{xs: '100%', md: '50%'}}
                        >
                            <Typography
                                fontWeight={900}
                                fontSize={{xs: 60, md: 100}}
                                lineHeight={1.25}
                                textAlign='center'
                                data-aos="fade-up"
                            >
                                404
                            </Typography>

                            <Typography
                                fontWeight={400}
                                fontSize={{xs: 14, md: 16}}
                                lineHeight={1.5}
                                letterSpacing={1}
                                textAlign='center'
                                sx={{
                                    pt: {xs: 1, md: 2},
                                    pb: {xs: 3, md: 5}
                                }}
                                color={theme.palette.text.secondary}
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                {t(`notFound.description`)}
                            </Typography>

                            <Box
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                <CustomButton 
                                    label={t(`notFound.home`)}
                                    onClick={() => navigate('/')}
                                    endIcon={<HomeIcon />}
                                    needAnimation
                                />
                            </Box>
                        </Stack>
                    </Stack>
                </Box>

                <FooterLayout />
            </Box>
        </>
    );
}

export default NotFoundLayout;